import script from "./PersonaEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./PersonaEdit.vue?vue&type=script&lang=ts&setup=true"

import "./PersonaEdit.vue?vue&type=style&index=0&id=220b34d5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-220b34d5"]])

export default __exports__